import React from "react";
import Modal from "react-bootstrap/Modal";

function CustomModal(props) {
  const { heading, content, footer, icon: Icon } = props; 
  return (
    <Modal
      {...props}
      aria-labelledby="custom-modal"
    >
      <Modal.Header closeButton>
        {Icon && <Icon size={40} strokeWidth={1} />}
        <Modal.Title id="custom-modal-title">
          {heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {content}
      </Modal.Body>
      <Modal.Footer>
        {footer}
      </Modal.Footer>
    </Modal>
  );
}

export default CustomModal;